export const PRODUCT_MODULES = [
  {
    to: '/products/task',
    title: 'Tasks',
    iconClass: 'fas fa-tasks',
    text: 'Assign work, set reminders, and track progress across branches and departments.',
  },
  {
    to: '/products/snap-bill',
    title: 'Snap Bill',
    iconClass: 'fas fa-file-invoice',
    text: 'Capture expense bills with AI, push them to accounting, convert estimates to LPO, and verify SOA.',
  },
  {
    to: '/products/documents',
    title: 'Documents',
    iconClass: 'fas fa-file-alt',
    text: 'Store, share, and organize files with version history and expiry reminders.',
  },
  {
    to: '/products/projects',
    title: 'Projects',
    iconClass: 'fas fa-briefcase',
    text: 'Plan projects with owners, timelines, and stakeholder updates in one workspace.',
  },
  {
    to: '/products/credentials-vault',
    title: 'Credentials Vault',
    iconClass: 'fas fa-key',
    text: 'Store corporate and personal passwords and API keys with role-based sharing.',
  },
  {
    to: '/products/discussion-forum',
    title: 'Discussion Forum',
    iconClass: 'fas fa-comments',
    text: 'Keep team decisions in topic-based, searchable conversations instead of scattered chat.',
  },
];
